import { BaseModel } from "model/BaseModel";

export default class Atividade implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    cobranca: boolean;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        cobranca = false
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.cobranca = cobranca;
    }

}
